import { useUnreadConversations } from '@/data/conversation';

const NotificationDot = ({ conversationId }) => {
  const unreadConversations = useUnreadConversations();

  if (unreadConversations.isLoading && !unreadConversations.data) {
    return null;
  }

  const unreadConversation =
    unreadConversations.data.unreadConversations[conversationId];

  if (!unreadConversation) {
    return null;
  }

  return (
    <div className="absolute -top-1 -right-1 bg-red-500 w-3 h-3 rounded-full z-10" />
  );
};

export default NotificationDot;
